import React from "react";
import {useTranslation} from "react-i18next";
// local
import ButtonDelete from "../buttons/ButtonDelete";
import {CustomCounter} from "components/CustomCounter";
import cn from "classnames";

const SelectionRow = ({
  values,
  onRemove,
  disabledRemoveButton,
  small,
  tiny,
  prefixContent,
  suffixContent,
  transparent,
  nonStretch,
  bold,
  canSelectAllValue,
  maxItems,
  addClass,
  addClassItem,
}) => {
  const {t} = useTranslation();

  const isSelectAllValue = canSelectAllValue && values.length === canSelectAllValue.count;

  const tooltipText = values
    .filter((_, i) => i > maxItems - 1)
    .map((item) => t(item.label))
    .join(", ");
  const count = values.length - maxItems;

  const rowItem = (item, i) => (
    <div
      key={`${item}${i}`}
      className={cn(
        "multiselect-custom_item",
        {__small: small, __tiny: !!tiny},
        {"__no-remove-button": !onRemove},
        {[`__${item.color}`]: item.color},
        {__transparent: !!transparent},
        {__bold: !!bold},
        {"mr-0": isSelectAllValue || maxItems === 1},
        {[addClassItem]: !!addClassItem}
      )}
    >
      <span
        className={!!onRemove || (maxItems === 1 && !isSelectAllValue) ? "mr-2" : "mr-1"}
      >
        {t(item.label)}
      </span>
      {maxItems === 1 && maxItems < values.length && !isSelectAllValue && (
        <CustomCounter
          count={count}
          tooltip={tooltipText}
          small={small}
          tiny={tiny}
          addClass="ml-0 mr-1"
        />
      )}
      {!!onRemove && (
        <ButtonDelete
          disabled={disabledRemoveButton}
          isWhite
          onClick={() => onRemove(item.value)}
        />
      )}
    </div>
  );

  return (
    <div
      className={cn("multiselect-custom_list __wrapper", {
        [addClass]: !!addClass,
        "__non-stretch": !!nonStretch,
      })}
    >
      <div className="multiselect-custom_list __inner-wrapper">
        {prefixContent}
        {isSelectAllValue
          ? rowItem(canSelectAllValue.item, 0)
          : values.map((item, i) =>
              !!maxItems ? i < maxItems && rowItem(item, i) : rowItem(item, i)
            )}

        {!!maxItems && maxItems !== 1 && maxItems < values.length && (
          <CustomCounter count={count} tooltip={tooltipText} small addClass="ml-0 mr-1" />
        )}
        {suffixContent}
      </div>
    </div>
  );
};

export default SelectionRow;
